import { FC, forwardRef, type SVGProps, useEffect, useRef } from 'react';
import { ICONS } from 'common/config/constant';

export const createIcon = (
  SvgComponent: FC<SVGProps<SVGSVGElement>>,
  theme?: 'light' | 'dark' | 'default'
) => {
  return forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => {
    const svgRef = useRef<SVGSVGElement | null>(null);

    useEffect(() => {
      const svgElement = svgRef.current;
      if (svgElement && !theme) {
        const paths = svgElement.querySelectorAll('[stroke]');
        paths.forEach((path: Element) => {
          path.setAttribute('stroke', 'currentColor');
        });

        const fill = svgElement.querySelectorAll('[fill]');
        fill.forEach((path: Element) => {
          path.setAttribute('fill', 'currentColor');
        });
      }
    }, []);
    return <SvgComponent ref={ref || svgRef} {...props} />;
  });
};

const Icons = {
  dashBoard: createIcon(ICONS.dashBoard),
  admin: createIcon(ICONS.admin),
  category: createIcon(ICONS.category),
  upload: createIcon(ICONS.upload, 'default'),
  back: createIcon(ICONS.back),
  child: createIcon(ICONS.child),
  pinMenu: createIcon(ICONS.pinMenu),
  cloudDown: createIcon(ICONS.cloudDown),
  locked: createIcon(ICONS.locked),
  unlocked: createIcon(ICONS.unlocked),
  edit: createIcon(ICONS.edit),
  calendar: createIcon(ICONS.calendar),
  plus: createIcon(ICONS.plus),
  filter: createIcon(ICONS.filter),
  search: createIcon(ICONS.search),
  delete: createIcon(ICONS.delete),
  close: createIcon(ICONS.close),
  bold: createIcon(ICONS.bold),
  italic: createIcon(ICONS.italic),
  underline: createIcon(ICONS.underline),
  unorderedList: createIcon(ICONS.unorderedList),
  toastSuccess: createIcon(ICONS.toastSuccess, 'default'),
  toastError: createIcon(ICONS.toastError, 'default'),
  eyes: createIcon(ICONS.eyes),
  received: createIcon(ICONS.received),
  approve: createIcon(ICONS.approve),
  reject: createIcon(ICONS.reject),
  darkMode: createIcon(ICONS.darkMode),
  draft: createIcon(ICONS.draft),
  global: createIcon(ICONS.global),
  eyeOff: createIcon(ICONS.eyeOff),
  alertRefuse: createIcon(ICONS.alertRefuse),
  logo: createIcon(ICONS.logo, 'default'),
  logoText: createIcon(ICONS.logoText),
  unpinMenu: createIcon(ICONS.unpinMenu),
  users: createIcon(ICONS.users),
  userSearch: createIcon(ICONS.userManagement),
  provider: createIcon(ICONS.provider),
  transaction: createIcon(ICONS.transaction),
  purchase: createIcon(ICONS.purchase),
  menu: createIcon(ICONS.menu),
  phone: createIcon(ICONS.phone),
  send: createIcon(ICONS.send),
  member: createIcon(ICONS.memberIcon),
  vip: createIcon(ICONS.vipIcon),
  premium: createIcon(ICONS.premiumIcon),
};

export default Icons;
